import Vue from "vue";
import Vuex from "vuex";
import { state } from "./state";
import * as getters from "./getters";
import * as actions from "./actions";
import * as mutations from "./mutations";
import plugins from "./plugins";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins
});

Vue.prototype.$store = Vue.store = store;

import cart from "./cart";
store.registerModule("cart", cart);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js